import React, { Component } from "react";
import PropTypes from "prop-types";
import * as _ from "lodash";
import Markdown from "react-markdown";
import gridHeadlineTextStyles from "./gridHeadlineText.module.pcss";

const GridHeadlineText = ({ features, columns }) => {
  const gridHeadlineContainerInlineTextStyles = {
    width: `calc(100% / ${columns} - 20px * 2)`
  };

  return (
    <div className={gridHeadlineTextStyles.gridHeadlineText}>
      {_.map(features, (feature, index) => {
        const text = _.get(feature, "text");
        const list = _.get(feature, "list");

        return (
          <div style={gridHeadlineContainerInlineTextStyles} key={index}>
            <Markdown source={feature.headline} />
            <Markdown source={list ? list.join("\n") : text} />
          </div>
        );
      })}
    </div>
  );
};

GridHeadlineText.propTypes = {
  features: PropTypes.array.isRequired,
  columns: PropTypes.number.isRequired
};

export default GridHeadlineText;



// WEBPACK FOOTER //
// ./src/templates/landing/components/gridSection/component/gridHeadlineText/gridHeadlineText.jsx